/**
 * Mutfak ekranının kıvrımlı (yılan) sırası.
 *
 * Kartlar satır satır, bir sağdan sola bir soldan sağa dizilir. Sıranın başı
 * (en eski fiş, 1 numara) her zaman sağ üst köşe (kullanıcı, 23 Eki 2026:
 * önceden satır sayısı tekken sol üste kayıyordu). Sıranın sonu (giriş) son
 * satırın yönüne göre sağ ya da sol alt köşe: yeni fiş oradan girer ve yol
 * boyunca sıranın sonuna kayar.
 *
 * Yol üzerinde ardışık iki yer ya yan yana (aynı satır) ya alt alta (satır
 * dönüşü, aynı sütun) durur; bu yüzden kart her adımda tek bir komşuya geçer.
 */

export interface Slot {
  row: number
  col: number
}

/** Yoldaki i. yer (0 = sıranın başı, sağ üst). İlk satır sağdan sola akar. */
export function snakeSlot(i: number, cols: number, _rows?: number): Slot {
  const row = Math.floor(i / cols)
  const k = i % cols
  const ltr = row % 2 === 1
  return { row, col: ltr ? k : cols - 1 - k }
}

/** from'dan to'ya yol üzerindeki bütün yerler (ikisi de dahil). */
export function snakePath(from: number, to: number): number[] {
  const step = to >= from ? 1 : -1
  const out: number[] = []
  for (let i = from; i !== to + step; i += step) out.push(i)
  return out
}
